module.exports = __webpack_public_path__ + "img/champ1.jpg";